document.addEventListener("DOMContentLoaded", function () {
  let currentAudio = null;
  const allProductIds = [];
  const _normalizerLink = document.createElement("a");

  // --- helpers ---------------------------------------------------------------
  function getNormalizedURL(url) {
    if (!url) return "";
    _normalizerLink.href = url;
    return _normalizerLink.href;
  }

  function findTrackIndex(audioElement, tracksArray) {
    if (!audioElement || !audioElement.src || audioElement.src === "") return -1;
    const currentNormalizedSrc = getNormalizedURL(audioElement.src);
    for (let i = 0; i < tracksArray.length; i++) {
      if (getNormalizedURL(tracksArray[i]) === currentNormalizedSrc) return i;
    }
    console.warn("Could not find track index for src:", audioElement.src, "in tracks:", tracksArray);
    return -1;
  }

  function getPlayers(scope) {
    const root = scope && scope.querySelectorAll ? scope : document;
    const players = Array.from(root.querySelectorAll(".mini-audio-player"));
    if (root.matches && root.matches(".mini-audio-player")) {
      players.unshift(root);
    }
    return players;
  }

  function refreshProductIds(scope) {
    const seen = new Set();
    const ids = [];
    getPlayers(scope || document).forEach(function (playerDiv) {
      const productId = (playerDiv.dataset && playerDiv.dataset.productId) ||
                        playerDiv.id.replace("mini-audio-player-", "");
      if (productId && !seen.has(productId)) {
        seen.add(productId);
        ids.push(productId);
      }
    });
    allProductIds.splice(0, allProductIds.length, ...ids);
  }

  // Use SVG icons for Play/Pause buttons (replaced FontAwesome for performance)
  function updatePlayPauseButton(id, isPlaying) {
    const btn = document.querySelector(`#mini-audio-player-${id} .mini-player-play`);
    if (!btn) return;
    const playHtml  = btn.dataset.playIcon  || '<svg aria-hidden="true" focusable="false" width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M8 5v14l11-7z"/></svg>';
    const pauseHtml = btn.dataset.pauseIcon || '<svg aria-hidden="true" focusable="false" width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M6 4h4v16H6V4zm8 0h4v16h-4V4z"/></svg>';
    btn.innerHTML = isPlaying ? pauseHtml : playHtml;
  }

  function pauseMainIfExists() {
    try {
      if (window.productPlayer && typeof window.productPlayer.pauseMainProductPlayer === "function") {
        window.productPlayer.pauseMainProductPlayer();
      }
      if (window.song && typeof window.song.pause === "function") {
        window.song.pause();
      }
    } catch (e) {
      console.warn("Could not pause main product player", e);
    }
  }

  // --- Event Delegation for Progress Bars (PERFORMANCE FIX #1) ---------------
  // Use event delegation instead of adding listeners in a loop
  document.addEventListener("click", function(event) {
    const progressBar = event.target.closest(".mini-progress");
    if (!progressBar) return;
    
    const idParts = progressBar.id.split("-");
    const clickedProductId = idParts[idParts.length - 1];
    const clickedAudio = document.getElementById(`audio-player-${clickedProductId}`);
    
    if (!clickedAudio) return;
    
    // Cache layout properties to avoid thrashing (PERFORMANCE FIX #2)
    const rect = progressBar.getBoundingClientRect();
    const width = progressBar.offsetWidth;
    
    if (!clickedAudio.src || !clickedAudio.duration || 
        clickedAudio.duration === Infinity || isNaN(clickedAudio.duration)) {
      window.miniPlayer.togglePlayPause(null, clickedProductId);
      return;
    }
    
    const percent = (event.clientX - rect.left) / width;
    clickedAudio.currentTime = percent * clickedAudio.duration;
  });

  // --- Lazy initialization (PERFORMANCE FIX #3) ------------------------------
  function initializeSinglePlayer(playerDiv) {
    const productId = (playerDiv.dataset && playerDiv.dataset.productId) ||
                      playerDiv.id.replace("mini-audio-player-", "");

    const tracksData = playerDiv.getAttribute("data-audio-tracks");
    const tracks = JSON.parse(tracksData || "[]");
    
    // Ensure play/pause icons are set (SVG icons from data attributes)
    const playBtn = playerDiv.querySelector(".mini-player-play");
    if (playBtn) {
      if (!playBtn.dataset.playIcon)  playBtn.dataset.playIcon  = '<svg aria-hidden="true" focusable="false" width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M8 5v14l11-7z"/></svg>';
      if (!playBtn.dataset.pauseIcon) playBtn.dataset.pauseIcon = '<svg aria-hidden="true" focusable="false" width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M6 4h4v16H6V4zm8 0h4v16h-4V4z"/></svg>';
    }

    if (tracks && tracks.length > 0 && productId && !allProductIds.includes(productId)) {
      allProductIds.push(productId);
    }

    const audio = document.getElementById(`audio-player-${productId}`);
    if (!audio) return;

    // Algolia replaces card HTML during filtering. The product id can be the
    // same, but the <audio> element is new and needs fresh listeners.
    if (audio._miniPlayerInitializedFor === productId) return;

    // avoid duplicate listeners on re-init
    audio.preload = "none";
    if (audio._updateProgressBarWrapper)
      audio.removeEventListener("timeupdate", audio._updateProgressBarWrapper);
    if (audio._loadedmetadataWrapper)
      audio.removeEventListener("loadedmetadata", audio._loadedmetadataWrapper);
    if (audio._handleTrackEndWrapper)
      audio.removeEventListener("ended", audio._handleTrackEndWrapper);
    if (audio._audioErrorWrapper)
      audio.removeEventListener("error", audio._audioErrorWrapper);

    const updateProgressBarWrapper = () => window.miniPlayer.updateProgressBar(productId);
    const loadedmetadataWrapper   = () => window.miniPlayer.updateProgressBar(productId);
    const handleTrackEndWrapper   = () => window.miniPlayer.handleTrackEnd(productId);
    const audioErrorWrapper       = (e) => console.error(`Audio Error for ${productId}:`, e);

    audio.addEventListener("loadedmetadata", loadedmetadataWrapper);
    audio.addEventListener("timeupdate",     updateProgressBarWrapper);
    audio.addEventListener("ended",          handleTrackEndWrapper);
    audio.addEventListener("error",          audioErrorWrapper);

    audio._updateProgressBarWrapper = updateProgressBarWrapper;
    audio._loadedmetadataWrapper    = loadedmetadataWrapper;
    audio._handleTrackEndWrapper    = handleTrackEndWrapper;
    audio._audioErrorWrapper        = audioErrorWrapper;
    audio._miniPlayerInitializedFor = productId;
  }

  // --- Initialize players lazily (PERFORMANCE FIX #4) ------------------------
  function initializeMiniPlayers(scope) {
    const root = scope && scope.querySelectorAll ? scope : document;
    const players = getPlayers(root);
    refreshProductIds(root);

    // Use requestIdleCallback for non-critical initialization
    if ('requestIdleCallback' in window) {
      requestIdleCallback(function() {
        players.forEach(initializeSinglePlayer);
      }, { timeout: 2000 });
    } else {
      // Fallback: use setTimeout to defer initialization
      setTimeout(function() {
        players.forEach(initializeSinglePlayer);
      }, 100);
    }
  }

  // Initialize existing players lazily
  initializeMiniPlayers();

  // --- Optimized MutationObserver (PERFORMANCE FIX #5) -----------------------
  // Re-init when new mini-players get injected (product recs, quick-add, filters, etc.)
  const mpObserver = new MutationObserver((mutations) => {
    // Batch DOM reads
    const newPlayers = [];
    for (const m of mutations) {
      for (const n of m.addedNodes || []) {
        if (n.nodeType === 1) {
          if (n.matches && n.matches(".mini-audio-player")) {
            newPlayers.push(n);
          } else if (n.querySelector) {
            const found = n.querySelector(".mini-audio-player");
            if (found) newPlayers.push(found);
          }
        }
      }
    }
    
    // Batch DOM writes
    if (newPlayers.length > 0) {
      if ('requestIdleCallback' in window) {
        requestIdleCallback(function() {
          refreshProductIds(document);
          newPlayers.forEach(initializeSinglePlayer);
        }, { timeout: 1000 });
      } else {
        setTimeout(function() {
          refreshProductIds(document);
          newPlayers.forEach(initializeSinglePlayer);
        }, 50);
      }
    }
  });
  mpObserver.observe(document.body, { childList: true, subtree: true });

  // Dawn/Shopify editor events — safe no-ops if they never fire
  document.addEventListener("shopify:section:load", initializeMiniPlayers);
  document.addEventListener("shopify:section:select", initializeMiniPlayers);
  document.addEventListener("shopify:section:deselect", initializeMiniPlayers);
  document.addEventListener("shopify:section:reorder", initializeMiniPlayers);
  document.addEventListener("product-recommendations:updated", initializeMiniPlayers);

  function getNextProductId(currentId) {
    if (!allProductIds.length) return null;
    const index = allProductIds.indexOf(currentId);
    if (index === -1) return allProductIds[0];
    // prefer the next item; if only one, return itself
    return allProductIds.length === 1
      ? allProductIds[0]
      : allProductIds[(index + 1) % allProductIds.length];
  }

  // --- public API ------------------------------------------------------------
  window.miniPlayer = {
    initializeMiniPlayers,

    pauseAllMiniPlayers: function () {
      document.querySelectorAll(".mini-audio-player audio").forEach((audioElement) => {
        if (!audioElement.paused) {
          audioElement.pause();
          const id = audioElement.id.split("-").pop();
          updatePlayPauseButton(id, false);
        }
      });
    },

    togglePlayPause: function (event, id) {
      if (event) {
        event.stopPropagation();
        event.preventDefault();
      }
      
      // Lazy initialize this player if not already initialized
      const playerDiv = document.getElementById(`mini-audio-player-${id}`);
      if (playerDiv) initializeSinglePlayer(playerDiv);
      
      const audio = document.getElementById(`audio-player-${id}`);
      if (!audio || !playerDiv) return;

      if (!audio.src || audio.src === "") {
        const tracks = JSON.parse(playerDiv.getAttribute("data-audio-tracks") || "[]");
        if (tracks && tracks.length > 0) {
          audio.src = tracks[0];
          audio.load(); // kick metadata pipeline
          window.miniPlayer.updateProgressBar(id); // draw 0 immediately
        } else {
          console.warn("No tracks to play for player:", id);
          return;
        }
      }

      if (currentAudio && currentAudio !== audio) {
        currentAudio.pause();
        updatePlayPauseButton(currentAudio.id.split("-").pop(), false);
        window.miniPlayer.updateProgressBar(currentAudio.id.split("-").pop());
      }

      if (audio.paused) {
        pauseMainIfExists();
        window.miniPlayer.pauseAllMiniPlayers();
        audio
          .play()
          .then(() => {
            currentAudio = audio;
            updatePlayPauseButton(id, true);
            window.miniPlayer.updateProgressBar(id);
          })
          .catch((error) => console.error("Error playing audio:", error, audio.src));
      } else {
        audio.pause();
        updatePlayPauseButton(id, false);
      }
    },

    nextTrack: function (event, id) {
      if (event) {
        event.stopPropagation();
        event.preventDefault();
      }
      
      // Lazy initialize if needed
      const playerDiv = document.getElementById(`mini-audio-player-${id}`);
      if (playerDiv) initializeSinglePlayer(playerDiv);
      
      const audio = document.getElementById(`audio-player-${id}`);
      if (!playerDiv || !audio) return;

      const tracks = JSON.parse(playerDiv.getAttribute("data-audio-tracks") || "[]");
      if (!tracks || tracks.length === 0) return;

      let currentIndex = findTrackIndex(audio, tracks);

      if (currentAudio && currentAudio !== audio) {
        currentAudio.pause();
        updatePlayPauseButton(currentAudio.id.split("-").pop(), false);
      }
      audio.pause();
      updatePlayPauseButton(id, false);

      if (currentIndex === -1 || currentIndex >= tracks.length - 1) {
        // go to next product in grid
        const nextId = getNextProductId(id);
        if (!nextId || (nextId === id && allProductIds.length === 1 && tracks.length <= 1)) {
          // only one playable thing on page: restart first track
          if (tracks.length > 0) {
            audio.src = tracks[0];
            audio.load();
            pauseMainIfExists();
            window.miniPlayer.pauseAllMiniPlayers();
            audio
              .play()
              .then(() => {
                currentAudio = audio;
                updatePlayPauseButton(id, true);
                window.miniPlayer.updateProgressBar(id);
              })
              .catch((e) => console.error("Error playing:", e));
          }
          return;
        }

        const nextPlayerDiv = document.getElementById(`mini-audio-player-${nextId}`);
        const nextAudio = document.getElementById(`audio-player-${nextId}`);
        if (!nextPlayerDiv || !nextAudio) return;

        const nextTracks = JSON.parse(nextPlayerDiv.getAttribute("data-audio-tracks") || "[]");
        if (!nextTracks || nextTracks.length === 0) return;

        if (currentAudio && currentAudio !== nextAudio) {
          currentAudio.pause();
          updatePlayPauseButton(currentAudio.id.split("-").pop(), false);
        }
        pauseMainIfExists();
        window.miniPlayer.pauseAllMiniPlayers();
        nextAudio.src = nextTracks[0];
        nextAudio.load();
        nextAudio
          .play()
          .then(() => {
            currentAudio = nextAudio;
            updatePlayPauseButton(nextId, true);
            window.miniPlayer.updateProgressBar(nextId);
          })
          .catch((e) => console.error("Error playing:", e));
      } else {
        // advance within same product
        pauseMainIfExists();
        window.miniPlayer.pauseAllMiniPlayers();
        audio.src = tracks[currentIndex + 1];
        audio.load();
        audio
          .play()
          .then(() => {
            currentAudio = audio;
            updatePlayPauseButton(id, true);
            window.miniPlayer.updateProgressBar(id);
          })
          .catch((e) => console.error("Error playing:", e));
      }
    },

    previousTrack: function (event, id) {
      if (event) {
        event.stopPropagation();
        event.preventDefault();
      }
      
      // Lazy initialize if needed
      const playerDiv = document.getElementById(`mini-audio-player-${id}`);
      if (playerDiv) initializeSinglePlayer(playerDiv);
      
      const audio = document.getElementById(`audio-player-${id}`);
      if (!playerDiv || !audio) return;

      const tracks = JSON.parse(playerDiv.getAttribute("data-audio-tracks") || "[]");
      if (!tracks || tracks.length === 0) return;

      let currentIndex = findTrackIndex(audio, tracks);

      if (currentAudio && currentAudio !== audio) {
        currentAudio.pause();
        updatePlayPauseButton(currentAudio.id.split("-").pop(), false);
      }
      audio.pause();
      updatePlayPauseButton(id, false);

      pauseMainIfExists();
      window.miniPlayer.pauseAllMiniPlayers();

      if (currentIndex <= 0) {
        audio.src = tracks[tracks.length - 1];
      } else {
        audio.src = tracks[currentIndex - 1];
      }
      audio.load();
      audio
        .play()
        .then(() => {
          currentAudio = audio;
          updatePlayPauseButton(id, true);
          window.miniPlayer.updateProgressBar(id);
        })
        .catch((e) => console.error("Error playing:", e));
    },

    updateProgressBar: function (id) {
      const audio = document.getElementById(`audio-player-${id}`);
      const progressBar = document.getElementById(`progress-bar-${id}`);
      if (!audio || !progressBar) return;

      if (!audio.duration || audio.duration === Infinity || isNaN(audio.duration)) {
        progressBar.value = 0;
        return;
      }
      const fraction = audio.currentTime / audio.duration;
      progressBar.value = isNaN(fraction) ? 0 : fraction;
    },

    handleTrackEnd: function (id) {
      const audio = document.getElementById(`audio-player-${id}`);
      const playerDiv = document.getElementById(`mini-audio-player-${id}`);
      if (!audio || !playerDiv) return;

      const tracks = JSON.parse(playerDiv.getAttribute("data-audio-tracks") || "[]");
      if (!tracks || tracks.length === 0) return;

      let currentIndex = findTrackIndex(audio, tracks);

      if (currentIndex === -1 || currentIndex >= tracks.length - 1) {
        audio.pause();
        updatePlayPauseButton(id, false);

        const nextId = getNextProductId(id);
        if (!nextId || (nextId === id && allProductIds.length === 1 && tracks.length <= 1)) {
          if (nextId === id && tracks.length > 1) {
            const nextPlayerDiv2 = document.getElementById(`mini-audio-player-${nextId}`);
            const nextAudio2 = document.getElementById(`audio-player-${nextId}`);
            const nextTracks2 = JSON.parse(nextPlayerDiv2.getAttribute("data-audio-tracks") || "[]");
            if (nextAudio2 && nextTracks2.length > 0) {
              pauseMainIfExists();
              window.miniPlayer.pauseAllMiniPlayers();
              nextAudio2.src = nextTracks2[0];
              nextAudio2.load();
              nextAudio2
                .play()
                .then(() => {
                  currentAudio = nextAudio2;
                  updatePlayPauseButton(nextId, true);
                  window.miniPlayer.updateProgressBar(nextId);
                })
                .catch((e) => console.error("Error playing:", e));
            }
          } else {
            if (currentAudio === audio) currentAudio = null;
            window.miniPlayer.updateProgressBar(id);
          }
          return;
        }

        const nextPlayerDiv = document.getElementById(`mini-audio-player-${nextId}`);
        const nextAudio = document.getElementById(`audio-player-${nextId}`);
        if (!nextPlayerDiv || !nextAudio) return;

        const nextTracks = JSON.parse(nextPlayerDiv.getAttribute("data-audio-tracks") || "[]");
        if (!nextTracks || nextTracks.length === 0) return;

        if (currentAudio && currentAudio !== nextAudio) {
          currentAudio.pause();
          updatePlayPauseButton(currentAudio.id.split("-").pop(), false);
        }
        pauseMainIfExists();
        window.miniPlayer.pauseAllMiniPlayers();
        nextAudio.src = nextTracks[0];
        nextAudio.load();
        nextAudio
          .play()
          .then(() => {
            currentAudio = nextAudio;
            updatePlayPauseButton(nextId, true);
            window.miniPlayer.updateProgressBar(nextId);
          })
          .catch((e) => console.error("Error playing:", e));
      } else {
        pauseMainIfExists();
        window.miniPlayer.pauseAllMiniPlayers();
        audio.src = tracks[currentIndex + 1];
        audio.load();
        audio
          .play()
          .then(() => {
            currentAudio = audio;
            updatePlayPauseButton(id, true);
            window.miniPlayer.updateProgressBar(id);
          })
          .catch((e) => console.error("Error playing:", e));
      }
    },
  };
});
